import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  token: string | null;
  setToken: (token: string | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      setToken: (token) => set({ token }),
      logout: () => set({ token: null }),
    }),
    {
      name: 'soraflo-auth',
    }
  )
);

export function useAuthHeaders() {
  const token = useAuthStore((state) => state.token);
  return {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  };
}
